import React, { ChangeEvent, FC } from "react"
import { Checkbox, MultiLineTextInput, SingleLineTextInput } from "dash-styled"

interface ExplanationProps {
    hint?: string
    onHintChange: (e: ChangeEvent<HTMLInputElement>) => void
    explanation?: string
    onExplanationChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
    isInteractive?: boolean
    toggleInteractive?: () => void
}

export const Explanation: FC<ExplanationProps> = ({
    hint,
    onHintChange,
    explanation,
    onExplanationChange,
    isInteractive,
    toggleInteractive
}) => {
    return (
        <>
            {isInteractive !== undefined && (
                <Checkbox
                    variant="modern"
                    isChecked={isInteractive}
                    onChange={toggleInteractive}
                    className="mb-2"
                >
                    Check this to make the example interactive
                </Checkbox>
            )}
            <SingleLineTextInput
                label="Hint"
                placeholder="Provide a hint of how the question would be solved”"
                value={hint}
                onChange={onHintChange}
            />

            <MultiLineTextInput
                label="Explanation"
                size="md"
                inputProps={{
                    value: explanation,
                    onChange: onExplanationChange,
                    rows: 10,
                    placeholder:
                        "Provide a detailed explanation on how the questions would be solved"
                }}
                variant="bordered"
            />
        </>
    )
}
